import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/code-management`;

export const codeManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:courseId`,
  view: `${baseRoute}/view/:courseId`,
  addMore: `${baseRoute}/add-more/:courseId`,
} as const;

export type ICodeManagementRouteParams = IExtractRouteParamMap<
  typeof codeManagementRoutesObj
>;

export const codeManagementPath = createPaths<
  typeof codeManagementRoutesObj,
  ICodeManagementRouteParams
>(codeManagementRoutesObj);
